<template>
    <v-row>
        <v-col cols="12">
            <h2 class="mt-5 mb-4">{{ title }}</h2>

            <v-text-field
                v-model="details.councilWaitingListReferenceNumber"
                label="Council waiting list reference number (if applicable)"
                outlined
                hide-details="auto"
                loading="true"
                class="rounded-0 mb-4"
                :error="getError(`applicants.${index}.councilWaitingListReferenceNumber`)"
                :error-messages="getErrorMessages(`applicants.${index}.councilWaitingListReferenceNumber`)"
                @input="removeErrorMessage(`applicants.${index}.councilWaitingListReferenceNumber`)"
            ></v-text-field>

            <legend class="v-label v-label--required theme--light mt-2 mb-2">
                Do you have any Pets?
            </legend>
            <v-radio-group
                v-model="details.ownPets"
                row
                :error="getError(`applicants.${index}.ownPets`)"
                :error-messages="getErrorMessages(`applicants.${index}.ownPets`)"
                @input="removeErrorMessage(`applicants.${index}.ownPets`)"
            >
                <v-radio
                    label="Yes"
                    :value="true"
                ></v-radio>
                <v-radio
                    label="No"
                    :value="false"
                ></v-radio>
            </v-radio-group>

            <!--
            <legend class="v-label theme--light">
                Owns Property *
            </legend>
            <v-radio-group
                class="mt-1"
                v-model="details.ownsProperty"
                row
                :error="getError(`applicants.${index}.ownsProperty`)"
                :error-messages="getErrorMessages(`applicants.${index}.ownsProperty`)"
                @input="removeErrorMessage(`applicants.${index}.ownsProperty`)"
            >
                <v-radio
                    label="Yes"
                    :value="true"
                ></v-radio>
                <v-radio
                    label="No"
                    :value="false"
                ></v-radio>
            </v-radio-group>
            -->

            <!--
            <v-select
                v-model="details.homeOwnershipStatus"
                :items="homeOwnershipStatusChoices"
                item-text="name"
                item-value="id"
                label="Home ownership status"
                outlined
                required
                hide-details="auto"
                class="rounded-0 mb-4 v-input--required"
                :rules="rules.homeOwnershipStatus"
                :error="getError(`applicants.${index}.homeOwnershipStatus`)"
                :error-messages="getErrorMessages(`applicants.${index}.homeOwnershipStatus`)"
                @input="removeErrorMessage(`applicants.${index}.homeOwnershipStatus`)"
            ></v-select>
            -->

            <!--
            <v-select
                v-model="details.currentHomeBeds"
                :items="currentHomeBedsChoices"
                item-text="name"
                item-value="id"
                label="Current home beds"
                outlined
                required
                hide-details="auto"
                class="rounded-0 mb-4 v-input--required"
                :rules="rules.currentHomeBeds"
                :error="getError(`applicants.${index}.currentHomeBeds`)"
                :error-messages="getErrorMessages(`applicants.${index}.currentHomeBeds`)"
                @input="removeErrorMessage(`applicants.${index}.currentHomeBeds`)"
            ></v-select>
            -->

            <!--
            <legend class="v-label theme--light mt-8">
                LA Registered *
            </legend>
            <v-radio-group
                class="mt-1"
                v-model="details.laRegistered"
                row
                :error="getError(`applicants.${index}.laRegistered`)"
                :error-messages="getErrorMessages(`applicants.${index}.laRegistered`)"
                @input="removeErrorMessage(`applicants.${index}.laRegistered`)"
            >
                <v-radio
                    label="Yes"
                    :value="true"
                ></v-radio>
                <v-radio
                    label="No"
                    :value="false"
                ></v-radio>
            </v-radio-group>
            -->

            <!--
            <legend class="v-label theme--light mt-2">
                Home Buy Registered *
            </legend>
            <v-radio-group
                class="mt-1"
                v-model="details.homeBuyRegistered"
                row
                :error="getError(`applicants.${index}.homeBuyRegistered`)"
                :error-messages="getErrorMessages(`applicants.${index}.homeBuyRegistered`)"
                @input="removeErrorMessage(`applicants.${index}.homeBuyRegistered`)"
            >
                <v-radio
                    label="Yes"
                    :value="true"
                ></v-radio>
                <v-radio
                    label="No"
                    :value="false"
                ></v-radio>
            </v-radio-group>
            -->

            <!--
            <legend class="v-label theme--light mt-2">
                Help to Buy Registered *
            </legend>
            <v-radio-group
                class="mt-1"
                v-model="details.helpToBuyRegistered"
                row
                :error="getError(`applicants.${index}.helpToBuyRegistered`)"
                :error-messages="getErrorMessages(`applicants.${index}.helpToBuyRegistered`)"
                @input="removeErrorMessage(`applicants.${index}.helpToBuyRegistered`)"
            >
                <v-radio
                    label="Yes"
                    :value="true"
                ></v-radio>
                <v-radio
                    label="No"
                    :value="false"
                ></v-radio>
            </v-radio-group>
            -->

            <!--
            <v-text-field
                v-model.number="details.dependants"
                type="number"
                label="Dependants"
                min="0"
                outlined
                required
                hide-details="auto"
                class="rounded-0 mb-4 v-input--required"
                :rules="rules.dependants"
                :error="getError(`applicants.${index}.dependants`)"
                :error-messages="getErrorMessages(`applicants.${index}.dependants`)"
                @input="removeErrorMessage(`applicants.${index}.dependants`)"
            ></v-text-field>
            -->
        </v-col>
    </v-row>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from '@vue/composition-api';
import HelperServices from "../../../services/HelperServices";
import {forEach, has, isEmpty} from "lodash";

export default defineComponent({
    name: 'Living',
    props: [
        'accessToken',
        'index',
        'title',
        'getError',
        'getErrorMessages',
        'removeErrorMessage',
        'loggedInProfile',
        'value',
        'formDisabled'
    ],
    setup(props, { emit }) {
        const accessToken = ref(null);
        const details = ref({
            ownsProperty: null,
            homeOwnershipStatus: null,
            currentHomeBeds: null,
            laRegistered: null,
            homeBuyRegistered: null,
            helpToBuyRegistered: null,
            ownPets: null,
            dependants: null,
            councilWaitingListReferenceNumber: null,
        });
        const homeOwnershipStatusChoices = ref([]);

        const rules = ref({
            homeOwnershipStatus: [
                v => !!v || 'Home ownership status is required',
            ],
            currentHomeBeds: [
                v => !!v || 'Current home beds is required',
            ],
            dependants : [
                v => v >= 0 || 'Value must be 0 or greater than 0',
            ],
        });

        const currentHomeBedsChoices = ref([
            { name: '1', id: 1 },
            { name: '2', id: 2 },
            { name: '3', id: 3 },
            { name: '4',  id: 4 },
            { name: '5',  id: 5 },
            { name: '6+',  id: 6 },
        ]);

        function setFields() {
            let currentFields = {};
            forEach(details.value, function(detValue, detKey) {
                if(has(props, 'value.' + detKey)) {
                    currentFields[detKey] = props.value[detKey];
                } else {
                    currentFields[detKey] = detValue;
                }
            });
            details.value = currentFields;
        }

        onMounted(() => {
            init();
        });

        function init() {
            emit('toggleLoading', true);
            if(props.accessToken !== '') {
                accessToken.value = props.accessToken;
            }
            Promise
                .all([
                    fetchOwnershipStatuses()
                ])
                .then(() => {
                    setFields();
                    emit("input", props.index, details.value);
                    emit('toggleLoading', false);
                });
        }

        function fetchOwnershipStatuses() {
            return new Promise(function(resolve, reject) {
                emit('toggleLoading', true);
                HelperServices.getOwnershipStatuses()
                    .then(function (response) {
                        if(response.data.data) {
                            homeOwnershipStatusChoices.value = response.data.data;
                        }
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error)
                    })
                    .then(function () {
                        emit('toggleLoading', false);
                    });
            });
        }

        watch(details, (newData, oldData) => {
            emit("input", props.index, newData);
        }, {
            deep: true
        });

        return {
            details,
            rules,
            currentHomeBedsChoices,
            homeOwnershipStatusChoices
        }
    },
})
</script>
